// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gw-order-summary{border-bottom:2px solid;border-top:2px solid;font-size:var(--font-size-md);padding-bottom:var(--spacing-3xl);padding-top:var(--spacing-3xl)}.gw-order-summary__divider{border-color:var(--color-gray-300);border-style:solid;border-width:0 0 2px;margin-bottom:var(--spacing-xl);margin-top:var(--spacing-xl)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
